exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
exports.push([module.id, "hr[data-v-3dd3dfbb]{padding:0;border:none;border-top:medium double #f1f1f1;color:#f1f1f1;text-align:center}hr[data-v-3dd3dfbb]:after{content:\"§\";display:inline-block;position:relative;top:-.7em;font-size:1.5em;padding:0 .25em;background:#fff}", ""]);


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3dd3dfbb","scoped":true,"hasInlineConfig":true}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/document-parts/page-break.vue
// module id = 405
// module chunks = 0